import { model_info_new, type IModelInfo, type IPictureInfo } from "../../defines";
import type { IXML, IXMLElement } from "../../ditto";
import { xml_x_map, xml_2_map } from "./xml_x_map";

export function xml_x_model_info(xml: IXML, f: IModelInfo, tag: string) {
  const ret = xml.create(tag);
  ret.set_attr("id", f.id);
  ret.set_attr("path", f.path);
  ret.set_attr("variants", f.variants?.join());
  if (f.rotation) ret.set_arr_attr_soft("rotation", [f.rotation.x, f.rotation.y, f.rotation.z]);
  if (f.scale) ret.set_arr_attr_soft("scale", [f.scale.x, f.scale.y, f.scale.z]);
  if (f.offset) ret.set_arr_attr_soft("offset", [f.offset.x, f.offset.y, f.offset.z]);
  return ret;
}export function xml_2_model_info(el: IXMLElement): IModelInfo {
  const ret = model_info_new();
  ret.id /**/ = el.get_str('id', ret.id);
  ret.path /**/ = el.get_str('path', ret.path);
  ret.variants /**/ = el.get_str_arr('variants', ret.variants);
  const scale = el.nums_attr_soft('scale');
  if (scale?.some(v => v != null)) {
    const s: { x?: number; y?: number; z?: number } = {};
    if (scale[0] != null) s.x = scale[0] as number;
    if (scale[1] != null) s.y = scale[1] as number;
    if (scale[2] != null) s.z = scale[2] as number;
    ret.scale = s;
  }
  const offset = el.nums_attr_soft('offset');
  if (offset?.some(v => v != null)) {
    const s: { x?: number; y?: number; z?: number } = {};
    if (offset[0] != null) s.x = offset[0] as number;
    if (offset[1] != null) s.y = offset[1] as number;
    if (offset[2] != null) s.z = offset[2] as number;
    ret.offset = s;
  }
  const rotation = el.nums_attr_soft('rotation');
  if (rotation?.some(v => v != null)) {
    const s: { x?: number; y?: number; z?: number } = {};
    if (rotation[0] != null) s.x = rotation[0] as number;
    if (rotation[1] != null) s.y = rotation[1] as number;
    if (rotation[2] != null) s.z = rotation[2] as number;
    ret.rotation = s;
  }
  return ret;
}
export function xml_2_model_info_map(el: IXMLElement, tag: string): Record<string, IPictureInfo> | undefined {
  return xml_2_map(el, tag, xml_2_model_info);
}
export function xml_x_model_info_map(xml: IXML, map: Record<string, IPictureInfo> | undefined, tag: string) {
  return xml_x_map(xml, map, tag, xml_x_model_info);
}

